/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePalReauthSubmissionRequest
 */
export interface CreatePalReauthSubmissionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePalReauthSubmissionRequest
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePalReauthSubmissionRequest
     */
    pal_submission_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePalReauthSubmissionRequest
     */
    next_review_date: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePalReauthSubmissionRequest
     */
    external_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePalReauthSubmissionRequest
     */
    level?: string | null;
}

/**
 * Check if a given object implements the CreatePalReauthSubmissionRequest interface.
 */
export function instanceOfCreatePalReauthSubmissionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "pal_submission_id" in value;
    isInstance = isInstance && "next_review_date" in value;

    return isInstance;
}

export function CreatePalReauthSubmissionRequestFromJSON(json: any): CreatePalReauthSubmissionRequest {
    return CreatePalReauthSubmissionRequestFromJSONTyped(json, false);
}

export function CreatePalReauthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalReauthSubmissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
        'pal_submission_id': json['pal_submission_id'],
        'next_review_date': json['next_review_date'],
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
        'level': !exists(json, 'level') ? undefined : json['level'],
    };
}

export function CreatePalReauthSubmissionRequestToJSON(value?: CreatePalReauthSubmissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead_id': value.lead_id,
        'pal_submission_id': value.pal_submission_id,
        'next_review_date': value.next_review_date,
        'external_id': value.external_id,
        'level': value.level,
    };
}

